'use strict';

// ProfileCard class
var ProfileCard = (function(window, undefined) {

    var SELECTORS = {
        container: '.profile_card_container',
        content: '.profile_card_content',
        clip: '.clip'
    };

    var CLASSES = {
        containerClosed: 'profile_card_container--closed',
        bodyHidden: 'body--hidden'
    };

    function ProfileCard(id, el) {
        this.id = id;
        this._el = el;
        this._container = cash(this._el).find(SELECTORS.container)[0];
        this._clip = cash(this._el).find(SELECTORS.clip)[0];
        this._content = cash(this._el).find(SELECTORS.content)[0];
        this.isOpen = false;
    }

    ProfileCard.prototype.openCard = function(callback, pos) {
        var self = this;

        if (!this.isOpen) {
            var cards = $(".new_ee_profile_container")[self.id];
            if (cards) {
                $(cards).removeClass('hide');
                $(cards).find('.profile-heading').removeClass("hide");
                $(cards).find('.ee_profile_header').removeClass("hide");
            }

            // Slide content left (instant)
            if (this._content) this._content.style.transform = 'translateX(-400px)';

            // Clip image in (instant)
            if (this._clip) this._clip.setAttribute('r', 60);

            // Float container
            if (this._container) {
                cash(document.body).addClass(CLASSES.bodyHidden);
                this._container.style.transition = 'all 2s ease';
                this._container.style.width = '400px';
                this._container.style.height = '150px';
                this._container.style.transform = 'translate(0, 0)';
                if (callback) callback();
            }

            // Clip image out (instant)
            if (this._clip) this._clip.setAttribute('r', 400);

            // Slide content up (instant)
            if (this._content) {
                this._content.style.transform = 'translateX(0)';
                if (cards) $(cards).find(".profilecard").addClass("animated");
            }

            this.isOpen = true;
        } else {
            // Already open
            if (this._content) this._content.style.transform = 'translateX(-400px)';
            if (this._clip) this._clip.setAttribute('r', 400);
            if (this._content) this._content.style.transform = 'translateX(0)';
        }
    };

    ProfileCard.prototype.closeCard = function() {
        console.log("ProfileCard.closeCard called for id:", this.id);
        this.isOpen = false;

        if (this._container) {
            this._container.scrollTop = 0;
            cash(this._container).css('overflow', 'hidden');
        }

        if (this._el) {
            cash(this._el).find(".animated").removeClass('animated');
            cash(this._el).find('.ee_profile_header').addClass("hide");
            cash(this._el).find('.profile-heading').addClass("hide");

            var cards = $(".new_ee_profile_container")[this.id];
            if (cards) $(cards).addClass('hide');
        }

        // Clear inline styles
        if (this._container) this._container.style.cssText = '';
        if (this._content) this._content.style.cssText = '';

        cash(document.body).removeClass(CLASSES.bodyHidden);
    };

    ProfileCard.prototype.hideCard = function() {
        if (this._el) {
            this._el.style.transition = 'all 0.4s ease';
            this._el.style.transform = 'scale(0.8)';
            this._el.style.opacity = '0';
        }
    };

    ProfileCard.prototype.showCard = function() {
        if (this._el) {
            this._el.style.transition = 'all 0.01s';
            this._el.style.transform = 'scale(1)';
            this._el.style.opacity = '1';
        }
    };

    return ProfileCard;

})(window);


// Wrapper for managing multiple ProfileCards
var profileCardWrapper = (function() {

    var layout = [];
    var cardMap = {}; // maps Angular IDs (data-id) to layout indices

    function init() {
        var elements = cash('.profilecard');
        cash.each(elements, function(i, card) {
            var instance = new ProfileCard(i, card);
            layout[i] = { card: instance };

            // Map Angular ID (data-id attribute) to layout index
            var angularId = card.getAttribute('data-angular-id');
            if (angularId != null) cardMap[String(angularId)] = i;

            var cardImage = cash(card).find('.profile_card_image');
            var cardClose = cash(card).find('.profile_card_btn-close');

            // Bind clicks
            cash(cardImage).on('click', function(e) {
                openSequence(angularId, e);
            });
            cash(cardClose).on('click', function() {
                closeSequence(angularId);
            });

            // Initially hide all cards
            instance.hideCard();
        });
    }

    function getLayoutIndex(angularId) {
        angularId = String(angularId); // ensure string
        return cardMap.hasOwnProperty(angularId) ? cardMap[angularId] : null;
    }

    function openSequence(angularId, e) {
        var idx = getLayoutIndex(angularId);
        if (idx === null || !layout[idx] || !layout[idx].card) {
            console.log("No card found for Angular ID:", angularId);
            return;
        }

        var card = layout[idx].card;
        if (card.isOpen) return;

        layout.forEach(function(item, i) {
            if (i !== idx && item && item.card) item.card.hideCard();
        });

        card.showCard();
        card.openCard(null, { x: e ? e.clientX : 0, y: e ? e.clientY : 0 });
    }

    function closeSequence(angularId) {
        console.log("profileCardWrapper.closeCard called for Angular ID:", angularId);
        console.log("cardMap:", cardMap);

        var idx = getLayoutIndex(angularId);
        console.log("Mapped layout index:", idx);

        if (idx === null || !layout[idx] || !layout[idx].card) {
            console.log("No card found for this Angular ID");
            return;
        }

        var card = layout[idx].card;
        card.closeCard();

        layout.forEach(function(item, i) {
            if (i !== idx && item && item.card) item.card.showCard();
        });
    }

    return {
        init: init,
        openCard: openSequence,
        closeCard: closeSequence
    };

})();

// Initialize wrapper after DOM is ready
cash(document).ready(function() {
    profileCardWrapper.init();
});